export default "__VITE_ASSET__FHAY2pSx__"